<div [formGroup]="formGroup" class="pure-g">
  <div class="pure-u-1 p-b-16">
    <mc-textarea
      ngDefaultControl
      formControlName="remarks"
      textarea
      rows="4"
      maxlength="500"
      fit="small"
      [attr.invalid]="isControlInErrorState(formGroup.controls['remarks'])">
      <span slot="label">Remarks <span class="mds-neutral--weak__text-color">(Optional)</span></span>

      @if (formGroup.get('remarks')?.hasError('maxlength')) {
        <span slot="errormessage"> Remarks cannot exceed 500 characters </span>
      }
    </mc-textarea>
  </div>
</div>
